import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

type Props = { artistId: string; domainId: string; sendgridIpPool: string | null };

type UpdateEmailDomainIpPoolResponse = {
  domain: { id: string; sendgrid_ip_pool: string | null };
};

/**
 * Writes only the domain's IP pool. `null` clears it.
 *
 * It replaced the shared `PUT .../domains/{domainId}` route, which required a `username` — saving a
 * pool through it rewrote the domain's email local-part as a side effect. That route is gone.
 */
export const updateEmailDomainIpPool = async ({ artistId, domainId, sendgridIpPool }: Props) => {
  if (!artistId) throw Error('Artist ID is required');
  if (!domainId) throw Error('Domain ID is required');

  const url = `/web/studio/artists/${artistId}/emails/domains/${domainId}/ip-pool`;

  const response = await api.executePatchRequest<ObjectResponse<UpdateEmailDomainIpPoolResponse>>(url, {
    sendgrid_ip_pool: sendgridIpPool,
  });

  return response.data;
};
